@let apiResponse = data(); @if (apiResponse) {
<p-table
  id="puResultTable"
  [value]="apiResponse.data"
  [loading]="dokAfsendelseService.datasource.isLoading()"
  [showGridlines]="true"
  [scrollable]="true"
  scrollHeight="flex"
  stripedRows
  class="p-datatable-sm lp-table"
  selectionMode="multiple"
  [(selection)]="dokAfsendelseService.selectedDokumenter"
  dataKey="id"
  [lazy]="true"
  [lazyLoadOnInit]="false"
  (onLazyLoad)="onLazyLoad($event)"
  sortField="id"
  [sortOrder]="1"
  [paginator]="true"
  [rows]="100"
  [totalRecords]="apiResponse.totalRowCount"
  [showJumpToPageDropdown]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
      <th pSortableColumn="id" style="width: 100px">
        Id
        <p-sortIcon field="id" />
      </th>
      <th pSortableColumn="hovedRegNr" style="width: 100px">
        Regnr
        <p-sortIcon field="hovedRegNr" />
      </th>
      <th pSortableColumn="cprNummer">
        CPR nummer
        <p-sortIcon field="cprNummer" />
      </th>
      <th pSortableColumn="dokumentId">
        Dokument id
        <p-sortIcon field="dokumentId" />
      </th>
      <th pSortableColumn="antalForsoeg">
        Forsøg
        <p-sortIcon field="antalForsoeg" />
      </th>
      <th pSortableColumn="fejlbesked">
        Fejlbesked
        <p-sortIcon field="fejlbesked" />
      </th>
      <th pSortableColumn="status">
        Status
        <p-sortIcon field="status" />
      </th>
      <th pSortableColumn="tidspunkt">
        Tidspunkt
        <p-sortIcon field="tidspunkt" />
      </th>
    </tr>
  </ng-template>
  <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
    <tr [pSelectableRow]="item" class="cursor-pointer">
      <td>
        <p-tableCheckbox [value]="item" />
      </td>
      <td>{{ item.id }}</td>
      <td>{{ item.hovedRegNr }}</td>
      <td>{{ item.cprNummer }}</td>
      <td>{{ item.dokumentId }}</td>
      <td>{{ item.antalForsoeg }}</td>
      <td>{{ item.fejlbesked }}</td>
      <td>{{ item.status }}</td>
      <td class="numbers text-nowrap">
        {{ item.tidspunkt | date : "dd-MM-yyyy HH:mm:ss" }}
      </td>
    </tr>
  </ng-template>
</p-table>
}
